import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";
import { hasAdsense } from "@escapio/shared/state/client-settings";

// Dummy object as required by google.
const dummy = (...args) => {
	dummy.q = dummy.q || [];
	dummy.q.push(args);
};
dummy.t = 1 * new Date();
window._googCsa = dummy;

const optionsSnippet = document.getElementById("esc-adsense-config");
const globalOptions = optionsSnippet
	? JSON.parse(optionsSnippet.innerText)
	: {};

if (!hasAdsense) {
	globalOptions["adtest"] = "on";
}

window.addEventListener("load", () => {
	hasAllPurposesConsent.then(() => {
		const snippet = document.createElement("script");
		snippet.src = "https://www.google.com/adsense/search/async-ads.js";
		snippet.setAttribute("defer", "");
		document.head.appendChild(snippet);
	});
});

export default (method, pageOptions, params) => {
	// Mix in the default options.
	Object.assign(pageOptions, globalOptions);

	// Use always the global dummy as it'll be replaced by the google code.
	return window._googCsa(method, pageOptions, params);
};
